export function applications(state) {
	return state.applications;
}

export function active_application(state) {
	if (state.active_application === null) {
		return null;
	}

	return state.applications.find(function(a) {
		if (a.id === state.active_application) {
			return a;
		}
	});
}

export function active_application_id(state) {
	return state.active_application;
}

export function application_status(state) {
	return state.application_status;
}
